<template>
  <div class="new-head">
    <div class="top-wrapp wrapper flex align-center">
      <div class="img-wrap" @click.stop="nav">
        <img src="@/assets/forum/new-logo.png" alt="" />
      </div>
      <div class="logo-desc flex-direction flex" @click.stop="nav">
        <div style="font-weight: 600">2022中国 贵港</div>
        <div style="font-weight: 600">电动车国际高峰论坛</div>
      </div>
    </div>
    <div class="top-nav">
      <div class="top-nav-wrap wrapper flex">
        <div
          class="nav-item"
          :class="curIndex == index ? 'active' : ''"
          v-for="(item, index) in navList"
          :key="index"
          @click.stop="navTo(index)"
        >
          {{ item }}
        </div>
      </div>
      <div
        class="burger disp-no"
        :class="open ? 'slideDown open' : 'goclose'"
        @click="openMiniNav"
      >
        <div class="top-line"></div>
        <div class="middle-line"></div>
        <div class="bottom-line"></div>
      </div>
    </div>

    <el-drawer
      size="80%"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <div
        class="nav-items"
        :class="curIndex == index ? 'active' : ''"
        v-for="(item, index) in navList"
        :key="index"
        @click.stop="navTo(index)"
      >
        {{ item }}
      </div>
    </el-drawer>
  </div>
</template>

<script>
import newfoot from "./foot";
export default {
  components: {
    newfoot,
  },
  data() {
    return {
      navList: [
        "大会简介",
        "新闻通稿",
        "精彩图片",
        "活动视频",
        "活动会议",
        "活动地图",
        "位置交通",
      ],
      curIndex: -1,
      open: false,
      drawer: false,
      direction: "rtl",
    };
  },
  watch: {
    $route: {
      //handler 方法就相当于普通侦听器触发的事件,即:当数据变化时要执行的操作
      handler: function (newV, oldV) {
        console.log("123333", newV, "123333");
        if (newV.path.indexOf("generalassembly") > -1) {
          this.curIndex = 0;
        } else if (newV.path.indexOf("newsnotice") > -1) {
          this.curIndex = 1;
        } else {
          this.curIndex = -1;
        }

        // this.show='new'
        // this.curpath = newV.name;
      },
      immediate: true, //当监听的属性为一个对象的时候添加deep:true才可以起作用
    },
  },
  methods: {
    openMiniNav() {
      this.open = true;
      this.drawer = true;
    },
    handleClose(done) {
      done();
      this.open = false;
    },
    navTo(i) {
      this.curIndex = i;
      switch (i) {
        case 0:
          this.$router.push("/generalassembly");
          break;
        case 1:
          this.$router.push("/newsnotice");
          break;
        case 2:
          this.$router.push("/picture");
          break;
        case 3:
          this.$router.push("/newVideo");
          break;
        default:
          console.log("no event");
      }
    },
    nav() {
      this.$router.push("/forum");
    },
  },
};
</script>

<style lang='less' scoped>
.img-wrap,
.logo-desc {
  cursor: pointer;
}
.nav-items {
  cursor: pointer;
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  height: 25px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ebebeb;
  padding: 0 5px;
  &.active {
    color: #4c50db;
  }
}

.disp-no {
  display: none;
}
.wrapper {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}
.new-head {
  .top-wrapp {
    .img-wrap {
      width: 68px;
      height: 68px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .logo-desc {
      margin-left: 10px;
      text-align: left;
      font-size: 18px;
      font-weight: 600;
      color: #7c54e6;
      line-height: 22px;
    }
  }
  .top-nav {
    position: relative;
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #4c50db;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    font-size: 18px;
    font-weight: 400;
    color: #ffffff;

    .top-nav-wrap {
      cursor: pointer;
      .nav-item {
        width: calc(100% / 7);
        text-align: center;
        transition: 0.4s ease;
        &.active {
          background: #9b2ef0;
        }
        &:hover {
          background: #9b2ef0;
        }
      }
    }
  }
}
@media screen and (max-width: 860px) {
  .new-head {
    .top-nav {
      .top-nav-wrap {
        display: none;
      }
    }
  }
  .burger {
    display: block !important;
  }
  .burger {
    position: absolute;
    top: 50%;
    transform: translateY(-45%);
    right: 30px;
    width: 20px;
    height: 6px;
    z-index: 999;
    cursor: pointer;
  }
  .burger .top-line,
  .burger .middle-line,
  .burger .bottom-line {
    width: 25px;
    height: 2px;
    background-color: white;
  }
  .burger .top-line {
    position: absolute;
    top: -6px;
  }
  .burger .middle-line {
    width: 15px;
  }
  .burger .bottom-line {
    position: absolute;
    top: 6px;
  }
  @keyframes slideDown {
    from {
      width: 0;
      height: 0;
    }
    to {
      width: 100%;
      height: calc(100vh - 100px);
      padding-left: 20px;
      opacity: 1;
    }
  }
  .goclose .top-line,
  .goclose .middle-line,
  .goclose .bottom-line,
  .open .top-line,
  .open .middle-line,
  .open .bottom-line {
    transition: 0.4s ease;
  }

  .open .top-line {
    transform: rotate(45deg) translate(3px, 5px);
  }
  .goclose .top-line {
    transform: rotate(0deg) translate(0px, 0px);
  }

  .open .middle-line {
    transform: translateX(5px);
    opacity: 0;
  }
  .goclose .middle-line {
    transform: translateX(0px);
    opacity: 1;
  }

  .open .bottom-line {
    transform: rotate(-45deg) translate(3px, -5px);
  }
  .goclose .bottom-line {
    transform: rotate(0deg) translate(0px, 0px);
  }
}
</style>